import { render, staticRenderFns } from "./DetalleForm.vue?vue&type=template&id=12008d33&"
import script from "./DetalleForm.vue?vue&type=script&lang=ts&"
export * from "./DetalleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('12008d33', component.options)
    } else {
      api.reload('12008d33', component.options)
    }
    module.hot.accept("./DetalleForm.vue?vue&type=template&id=12008d33&", function () {
      api.rerender('12008d33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Clientes/DetalleForm.vue"
export default component.exports